<template>
    <div class="service-windows flex flex-direction align-end">
        <div class="service-info_item flex">
            <div class="phone-container flex align-end">
                <img src="../../../assets/img/erweima_kf.png" alt="合作咨询" class="scan">
                <div class="flex flex-direction self-center margin-right-xs">
                    <div class="phone">13051052979 </div>
                    <div class="title">(微信同号) 刘老师</div>
                </div>
            </div>
            <div class="tag flex align-center justify-center">合作<br>洽谈</div>
        </div>
        <div class="service-info_item flex margin-tb-xs">
            <div class="phone-container flex align-end">
                <img src="../../../assets/img/erweima_kf_jj.png" alt="技术支持" class="scan">
                <div class="flex flex-direction self-center margin-right-xs">
                    <div class="phone">400 999 6541</div>
                    <div class="title">佳佳</div>
                </div>
            </div>
            <div class="tag flex align-center justify-center">技术<br>支持</div>
        </div>
        <div class="service-info_item flex">
            <div class="phone-container flex align-end">
                <img src="../../../assets/img/erweima_kf_rz.png" alt="投诉建议" class="scan">
                <div class="flex flex-direction self-center margin-right-xs">
                    <div class="phone">13121702211</div>
                    <div class="title">(微信同号) 任老师</div>
                </div>
            </div>
            <div class="tag flex align-center justify-center">投诉<br>建议</div>
        </div>
        <div class="service-info_item flex margin-top-xs">
            <router-link class="tag flex align-center justify-center" to="/web/help">帮助<br>中心</router-link>
        </div>
    </div>

</template>

<script>
export default {
    name: "HelpWindows"
}
</script>

<style scoped >

@media screen and (max-width:1300px) {
    .service-windows{
        display: none;
    }
}
.service-windows {
    position: fixed;
    right: 30px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1024;
}


.service-windows .service-info_item .tag {
    width: 60px;
    height: 60px;
    text-align: center;
    background: #1569be;
    font-size: 14px;
    color: #acd5ff;
    cursor: pointer;
    position: relative;
}

.service-windows .service-info_item:not(:last-child) .tag{
    clip-path: polygon(50% -8px, 100% 0, 100% 43%, 100% 100%, 60% 100%, 50% 89%, 40% 100%, 0 100%, 0 0);
}

.service-windows .service-info_item:not(:first-child) .tag::after {
    position: absolute;
    top: -6px;
    border-left: 8px solid transparent;
    border-bottom: 8px solid #1569be;
    border-right: 8px solid transparent;
    left: 50%;
    transform: translateX(-50%);
    content: '';
}

.service-windows .service-info_item:hover .tag::after {
    border-bottom: 8px solid #ff9600;
}



.service-windows .service-info_item:hover .tag {
    background: #ff9600;
    color: #fff;
}

.service-windows .service-info_item .phone-container {
    height: 60px;
    background-color: #09498b;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    display: none;
}

.service-windows .service-info_item:hover .phone-container {
    display: flex;
}



.service-windows .service-info_item .phone {
    font-size: 14px;
    color: #ff9704;
    font-weight: 600;
}

.service-windows .service-info_item .title {
    font-size: 12px;
    color: #ffffff;
}

.service-windows .service-info_item .scan {
    width: 66px;
    height: 66px;
    border-radius: 10px;
    margin: 6px;
    border: solid 1px #105091;
}

</style>